var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeopleQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "request 1",
    clipPath: "url(#clip0_47220_1596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M74.6278 47.1045C74.6278 48.7874 73.2639 50.1514 71.5809 50.1514C69.8988 50.1514 68.5341 48.7874 68.5341 47.1045C68.5341 45.4224 69.8988 44.0576 71.5809 44.0576C73.2639 44.0576 74.6278 45.4224 74.6278 47.1045Z",
    fill: "#3267E3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M71.5778 14.6865C65.3928 14.6865 60.3757 19.6917 60.3757 25.8885V25.8925C60.3757 27.5746 61.7397 28.9378 63.4226 28.9378C65.1055 28.9378 66.4695 27.5715 66.4695 25.8885C66.4695 23.0718 68.7475 20.7803 71.5817 20.7803C74.4001 20.7803 76.6932 23.0734 76.6932 25.8925C76.6932 28.7109 74.4001 31.004 71.5817 31.004C69.8988 31.004 68.5349 32.3687 68.5349 34.0508V37.3143C68.5349 38.9973 69.8988 40.3612 71.5817 40.3612C73.2639 40.3612 74.6286 38.9973 74.6286 37.3143V36.6772C79.3314 35.3466 82.7869 31.0151 82.7869 25.8925C82.7869 19.7131 77.7604 14.6865 71.5778 14.6865Z",
    fill: "#3267E3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M29.2373 77.7588C33.0237 74.8103 35.4659 70.213 35.4659 65.054C35.4659 56.176 28.2423 48.9531 19.3643 48.9531C10.4863 48.9531 3.26349 56.176 3.26349 65.054C3.26349 70.213 5.70575 74.8103 9.49133 77.7588C4.14819 80.9374 0 86.9407 0 94.4261V100.953C0 102.636 1.36395 104 3.04688 104H35.6826C37.3647 104 38.7294 102.636 38.7294 100.953V94.4261C38.7294 86.9423 34.582 80.9382 29.2373 77.7588ZM9.35724 65.054C9.35724 59.5363 13.8466 55.0469 19.3651 55.0469C24.8828 55.0469 29.3722 59.5363 29.3722 65.054C29.3722 70.5724 24.8828 75.0618 19.3651 75.0618C13.8466 75.0618 9.35724 70.5724 9.35724 65.054ZM32.6357 97.9062H6.09375V94.4261C6.09375 87.0962 12.024 81.1556 19.3643 81.1556C26.6943 81.1556 32.6349 87.0859 32.6349 94.4261V97.9062H32.6357Z",
    fill: "#3267E3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M91.1626 0H51.9999C44.9096 0 39.1626 5.7367 39.1626 12.8373V71.581C39.1626 74.0732 42.0206 75.5308 44.0376 74.0185L56.2791 64.8374H91.1626C98.2529 64.8374 104 59.1007 104 52V12.8373C104 5.74701 98.2632 0 91.1626 0V0ZM97.9062 52C97.9062 55.7277 94.8918 58.7436 91.1626 58.7436H55.2634C54.6041 58.7436 53.963 58.9579 53.4353 59.353L45.2563 65.4872V12.8373C45.2563 9.10969 48.2707 6.09375 51.9999 6.09375H91.1626C94.8903 6.09375 97.9062 9.1081 97.9062 12.8373V52Z",
    fill: "#3267E3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47220_1596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleQuestion);
export default __webpack_public_path__ + "static/media/people-question.1ca4b2561ceb3f0967b163a8a36ee757.svg";
export { ForwardRef as ReactComponent };